import { render, staticRenderFns } from "./RollingCellTemplate.vue?vue&type=template&id=704b54d7&scoped=true&"
import script from "./RollingCellTemplate.vue?vue&type=script&lang=js&"
export * from "./RollingCellTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704b54d7",
  null
  
)

export default component.exports